export default class Styleguide {
  constructor() {
    this.elements = {
      colorTarget: document.querySelector('.js-styleguide-colors'),
      typographyTarget: document.querySelector('.js-styleguide-typography '),
    };

    if (this.elements.colorTarget) {
      this.initColors();
    }
    if (this.elements.typographyTarget) {
      this.initTypography();
    }
  }

  initColors() {
    const elements = this.elements.colorTarget.querySelectorAll('.js-styleguide-color-item');

    if (!elements.length) {
      return;
    }

    // Function to convert hex format to a rgb color
    function rgb2hex(orig) {
      const rgb = orig.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+)/i);
      return rgb && rgb.length === 4
        ? (`#0${parseInt(rgb[1], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(rgb[2], 10).toString(16)}`).slice(-2)
        + (`0${parseInt(rgb[3], 10).toString(16)}`).slice(-2)
        : orig;
    }

    for (let i = 0; i < elements.length; i++) {
      const item = elements[i];
      const itemSource = item.querySelector('.js-styleguide-color-source');
      const bgColor = window
        .getComputedStyle(itemSource, null)
        .getPropertyValue('background-color');
      const DestRgb = item.querySelector('.js-styleguide-color-rgb');
      const DestHex = item.querySelector('.js-styleguide-color-hex');

      if (DestHex) {
        DestHex.innerHTML = rgb2hex(bgColor);
      }
      if (DestRgb) {
        DestRgb.innerHTML = bgColor;
      }
    }
  }

  initTypography() {
    const elements = this.elements.typographyTarget.querySelectorAll('.js-styleguide-typography-item');

    if (!elements.length) {
      return;
    }

    for (let i = 0; i < elements.length; i++) {
      const item = elements[i];
      const itemSource = item.querySelector('.js-styleguide-typography-source');

      const fontFamily = window
        .getComputedStyle(itemSource, null)
        .getPropertyValue('font-family');
      const fontSize = window
        .getComputedStyle(itemSource, null)
        .getPropertyValue('font-size');
      const lineHeight = window
        .getComputedStyle(itemSource, null)
        .getPropertyValue('line-height');
      const fontWeight = window
        .getComputedStyle(itemSource, null)
        .getPropertyValue('font-weight');
      const fontStyle = window
        .getComputedStyle(itemSource, null)
        .getPropertyValue('font-style');

      const DestInfo = item.querySelector('.js-styleguide-typography-dest');

      if (DestInfo) {
        DestInfo.innerHTML = `${fontFamily.split(',')[0]} ${fontWeight} ${fontStyle}<br>font-size ${fontSize} / line-height ${lineHeight}`;
      }
    }
  }
}
